<div class="w-full">
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h6 *ngIf="!viewMode && !milestoneDetails?.milestone_title" mat-dialog-title class="font-semibold primary-font">
          {{'text.project.milestone.create' | translate}}
      </h6>
      <h6 *ngIf="!viewMode && milestoneDetails?.milestone_title" mat-dialog-title class="font-semibold primary-font">
          {{'text.project.milestone.update' | translate}}
      </h6>
      <h6 *ngIf="viewMode" mat-dialog-title class="font-semibold primary-font">
        {{'text.project.milestone.details' | translate}}
      </h6>
      <div class="flex items-center mr-1">
          <span mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
              <em class="ti ti-x text-xl font-bold"></em>
          </span>
      </div>
  </div>
  <div class="flex flex-col">
      <form [formGroup]="milestoneFormGroup" class="w-full" ngNativeValidate>
          <div class="zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
              <div class="w-full">
                  <div class="mb-2">
                      <label for="phase" [ngClass]="viewMode ? 'block text-base font-bold': 'block text-base font-medium text-gray-600 cursor-pointer'">
                          {{"text.phase" | translate}}
                      </label>
                      <div class="primary-font text-base font-normal" *ngIf="viewMode; else editPhase">
                          {{  milestoneDetails?.phase }}
                      </div>
                      <ng-template #editPhase>
                          <mat-form-field appearance="fill" class="w-full mt-1">
                              <mat-select formControlName="phase">
                                  <mat-option *ngFor="let phase of phases" [value]="phase.phase_uid">
                                      {{ phase.phase_name }}
                                  </mat-option>
                              </mat-select>
                          </mat-form-field>
                      </ng-template>
                  </div>
              </div>
              <div class="grid grid-cols-2 gap-4 mt-5">
                  <div class="example-full-width" appearance="fill" ngClass="w-full">
                      <label [ngClass]="viewMode ? 'text-base mb-2 font-bold': 'required text-base mb-2 font-medium text-gray-600'">{{'name.text' | translate}}</label>
                      <div class="primary-font text-base font-normal"  *ngIf="viewMode; else editName">
                          {{ milestoneFormGroup.get('name').value }}
                      </div>
                      <ng-template #editName>
                          <input type="text" formControlName="name" name="name" id="name"
                                 class="form-control mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                                 placeholder="{{'text.project.milestone.placeholder.example' | translate}}">
                          <mat-error *ngIf="milestoneFormGroup?.controls?.name?.invalid && milestoneFormGroup?.controls?.name?.touched"
                                     class="primary-font font-semibold text-base">
                              {{'text.field_is_required' | translate}}
                          </mat-error>
                      </ng-template>
                  </div>
                  <div class="example-full-width" ngClass="w-full">
                      <label [ngClass]="viewMode ? 'text-base mb-2 font-bold': 'required text-base mb-2 font-medium text-gray-600'">{{'due.date.text' | translate}}</label>
                      <div class="primary-font text-base font-normal"  *ngIf="viewMode; else editDueDate">
                          {{ milestoneDetails?.dueDate  }}
                      </div>
                      <ng-template #editDueDate>
                          <mat-form-field appearance="fill" ngClass="w-full" [floatLabel]="'always'">
                              <input type="text" matInput id="due_date" name="due_date" class="form-control"
                                     [matDatepicker]="toDatePicker" [datePickerFormat]="dateFormat" (focus)="toDatePicker?.open()"
                                     formControlName="due_date" placeholder="{{'text.choose_to_date' | translate}}">
                              <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #toDatePicker></mat-datepicker>
                              <mat-error *ngIf="milestoneFormGroup?.controls?.due_date?.invalid && milestoneFormGroup?.controls?.due_date?.touched"
                                         class="primary-font font-semibold text-base">
                                  {{'text.field_is_required' | translate}}
                              </mat-error>
                          </mat-form-field>
                      </ng-template>
                  </div>
              </div>
              <div class="w-full mt-5">
                  <label [ngClass]="viewMode ? 'primary-font text-base font-bold': 'primary-font text-base font-medium text-gray-600'">{{'description' | translate}}</label>
                  <div class="primary-font text-base font-normal"  *ngIf="viewMode; else editDescription">
                      {{ milestoneFormGroup.get('description').value || '--' }}
                  </div>
                  <ng-template #editDescription>
                      <mat-form-field class="example-full-width use-default-mat-height" appearance="fill" ngClass="w-full"
                                      [hideRequiredMarker]="true" [floatLabel]="'always'">
                          <textarea type="text" matInput id="description" name="description" class="form-control"
                                    formControlName="description" autocomplete="off" placeholder="{{'description' | translate}}"></textarea>
                      </mat-form-field>
                  </ng-template>
              </div>
            <div class="w-full flex items-center space-x-2 mt-3" *ngIf="!viewMode && !milestoneDetails?.progressive_invoice_uid && !progressiveInvoiceStatus && projectDetails?.progressive_invoicing?.is_enabled">
                <input type="checkbox" id="progressiveInvoiceInclusion" formControlName="progressiveInvoiceInclusion" />
                <label for="progressiveInvoiceInclusion"
                    class="block text-base flex items-center mt-2.5 font-medium mb-2 text-gray-700 cursor-pointer">{{'text.project.milestone.progressive.invoice.inclusion'
                    | translate}}</label>
            </div>
          </div>
          <div *ngIf="!viewMode" class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
              <div class="space-x-3">
                  <button mat-stroked-button [mat-dialog-close]="{ status: false }"
                          class="btn-small px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none"
                          type="button">{{'cancel.text' | translate}}</button>
                  <button *ngIf="!milestoneDetails?.milestone_title" mat-stroked-button
                          class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none"
                          (click)="createNewMilestone()">{{'create' | translate}}</button>
                  <button *ngIf="milestoneDetails?.milestone_title" mat-stroked-button
                          class="btn-small bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none"
                          (click)="updateMilestone()">{{'update' | translate}}</button>
              </div>
          </div>
      </form>
  </div>
</div>
